import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { AccessPermissionDataPayload, AccessPermissionDataResponse, AccessPermissionDataRolePayload, AccessPermissionDataRoleResponse } from "@/types/interface/access-permission";

async function createAccessPermission(payload: AccessPermissionDataPayload) {
  return await http.post<APIResponse<AccessPermissionDataResponse>>("access-permission/create", payload);
}

async function updateAccessPermission(idAccessPermission = '', payload: AccessPermissionDataPayload) {
  return await http.patch<APIResponse<AccessPermissionDataResponse>>(`access-permission/update?id=${idAccessPermission}`, payload);
}

async function getAccessPermission(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<AccessPermissionDataResponse>>(`access-permission?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findAccessPermission(idAccessPermission = "") {
  return await http.get<APIResponse<AccessPermissionDataResponse>>(`access-permission/detail?id=${idAccessPermission}`);
}

async function deleteAccessPermission(idAccessPermission = "") {
  return await http.delete<APIResponse<AccessPermissionDataResponse>>(`access-permission/delete?id=${idAccessPermission}`);
}

async function getAccessPermissionByRole(idRole = 1) {
  return await http.get<APIResponse<AccessPermissionDataRoleResponse>>(`access-permission/access-permission-mapping-by-role?id=${idRole}`);
}

async function setRole(payload: AccessPermissionDataRolePayload) {
  return await http.post<APIResponse<AccessPermissionDataRoleResponse>>("access-permission/assign-by-role", payload);
}

export default {
  createAccessPermission,
  updateAccessPermission,
  getAccessPermission,
  findAccessPermission,
  deleteAccessPermission,
  getAccessPermissionByRole,
  setRole,
};